import { http, config } from './__http';

export default {
    // LIST PREORDERSHEETS
    getPreOrderSheets(sheets, params) {
        http.get(config.baseUrl()+'/PreOrderSheet', params).then(response => {
            sheets(response.data);
        }).catch(e => {
            sheets(e.response);
        });
    },
    copyPreOrderSheet(sheet, id) {
        http.post(config.baseUrl()+'/PreOrderSheet/'+id+'/copy').then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },

    // CRUD PREORDERSHEET
    createPreOrderSheet(sheet, PreOrderSheet) {
        http.post(config.baseUrl()+'/PreOrderSheet', PreOrderSheet).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },
    getPreOrderSheet(sheet, id) {
        http.get(config.baseUrl()+'/PreOrderSheet/'+id).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },
    getPreOrderSheetProducts(sheets, params) {
        http.get(config.baseUrl()+'/PreOrderSheet/'+params.id+'/productgroups', { params: params.body }).then(response => {
          sheets(response.data);
        }).catch(e => {
          sheets(e.response);
        });
    },
    getPreOrderSheetMarketingProducts(sheets, params) {
        http.get(config.baseUrl()+'/PreOrderSheet/'+params.id+'/marketingproductgroups', { params: params.body }).then(response => {
          sheets(response.data);
        }).catch(e => {
          sheets(e.response);
        });
    },
    updatePreOrderSheet(sheet, params) {
        http.put(config.baseUrl()+'/PreOrderSheet/'+params.Id, params.PreOrderSheet).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },

    // PREORDERSHEET SEARCH
    getPreOrdersSheetSearch(targets) {
        http.get(config.baseUrl()+'/PreOrderSheet/autocomplete').then(response => {
            targets(response.data);
        }).catch(e => {
            targets(e.response);
        });
    },

    // PRODUCT GROUPS
    addProductGroupToSheet(group, params) {
        http.post(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/productgroup', {
            ProductGroupId: params.productGroupId
        }).then(response => {
            group(response.data);
        }).catch(e => {
            group(e.response);
        });
    },
    updateProductGroupToSheet(group, params) {
        http.put(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/productgroup/'+params.productGroupId, {
            ...params.body
        }).then(response => {
            group(response.data);
        }).catch(e => {
            group(e.response);
        });
    },
    updateProductGroupSortIndexToSheet(group, params) {
        http.put(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/productgroup/'+params.productGroupId+'/sortindex/'+params.sortIndex).then(response => {
            group(response.data);
        }).catch(e => {
            group(e.response);
        });
    },
    removeProductGroupFromSheet(group, params) {
        http.delete(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/productgroup/'+params.productGroupId).then(response => {
            group(response.data);
        }).catch(e => {
            group(e.response);
        });
    },

    // PRODUCT
    addProductToSheet(product, params) {
        http.post(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/product',{
            ProductId: params.productId,
            ProductGroupId: params.productGroupId
        }).then(responsegroup => {
            product(response.data);
        }).catch(e => {
            product(e.response);
        });
    },
    removeProductFromSheet(product, params) {
        http.delete(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/product/'+params.productId).then(response => {
            product(response.data);
        }).catch(e => {
            product(e.response);
        });
    },
    updateProductInSheet(sheet, params) {
        http.put(config.baseUrl()+'/PreOrderSheet/'+params.preOrderSheetId+'/product/'+params.productId, params.body).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },

    // PRODUCT VARIANTS
    updateProductVariant(sheet, params) {
        http.put(config.baseUrl()+'/PreOrderSheet/'+params.preOrderSheetId+'/productvariant/'+params.productVariantId, params.body).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },

    // MARKETING GROUPS
    addMarketingGroupToSheet(group, params) {
        http.post(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/marketingproductgroup', {
            ProductGroupId: params.productGroupId
        }).then(response => {
            group(response.data);
        }).catch(e => {
            group(e.response);
        });
    },
    updateMarketingGroupToSheet(group, params) {
        http.put(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/marketingproductgroup/'+params.productGroupId, {
            ...params.body
        }).then(response => {
            group(response.data);
        }).catch(e => {
            group(e.response);
        });
    },
    removeMarketingGroupFromSheet(group, params) {
        http.delete(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/marketingproductgroup/'+params.productGroupId).then(response => {
            group(response.data);
        }).catch(e => {
            group(e.response);
        });
    },

    // MARKETING PRODUCT
    addMarketingToSheet(product, params) {
        http.post(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/marketingproduct',{
            ProductId: params.productId,
            ProductGroupId: params.productGroupId
        }).then(responsegroup => {
            product(response.data);
        }).catch(e => {
            product(e.response);
        });
    },
    removeMarketingFromSheet(product, params) {
        http.delete(config.baseUrl()+'/preordersheet/'+params.preOrderSheetId+'/marketingproduct/'+params.productId).then(response => {
            product(response.data);
        }).catch(e => {
            product(e.response);
        });
    },
    updateMarketingInSheet(sheet, params) {
        http.put(config.baseUrl()+'/PreOrderSheet/'+params.preOrderSheetId+'/marketingproduct/'+params.productId, params.body).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },


    getBrands(brands, params) {
		http.get(config.baseUrl()+'/brand', params).then(response => {
            brands(response.data);
        }).catch(e => {
            brands(e.response);
        });
    },
    getCollections(collections, params) {
        http.get(config.baseUrl()+'/brand/'+params.Id+'/collection', params).then(response => {
            collections(response.data);
        }).catch(e => {
            collections(e.response);
        });
    },

    //PREORDER SHEET REPORTING
    getSheetBaseData(sheet, id) {
        http.get(config.baseUrl()+'/preordersheet/base?sheetId=' + id).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },

    getSheetStats(sheet, sheetId, salesmanId, countryCode) {
        http.get(config.baseUrl()+'/preordersheet/report?sheetId=' + sheetId + '&salesmanId=' + salesmanId + '&country=' + countryCode).then(response => {
            sheet(response.data);
        }).catch(e => {
            sheet(e.response);
        });
    },

    downloadExport(csv, sheetId, salesmanId, countryCode) {
        http.get(config.baseUrl()+'/preordersheet/exportreport?sheetId=' + sheetId + '&salesmanId=' + salesmanId + '&country=' + countryCode).then(response => {
            csv(response.data)
        }).catch(e => {
            console.error(e);
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/PreOrderSheets.js